<template>
    <Loader />
    <router-view />
    <Overlay />
    <Notification />
</template>

<style>
    :root{
        --secondary-color: #72ad77 !important;
        --secondary-color-h: 123;
        --secondary-color-s: 41.2%;
        --secondary-color-l: 48%;
    }
</style>

<script>
    import Loader from '@/components/Loader.vue'
    import Overlay from "@/components/Overlay.vue";
    import Notification from "@/components/Notification.vue";
    import userState from "@/state/User";
    import topState from "@/state/Top";
    import dealerState from "@/state/Dealership";
    import analytics from "@/services/Analytics";

    export default {
        components: {
            Loader, Overlay, Notification
        },
        async created() {
            userState.init();
            analytics.init();
            await dealerState.init();
        },
        watch: {
            $route() {
                topState.overlay = null;
                topState.mobileMenu = false;
                topState.userMenu = false;

                analytics.page(this.$route.fullPath);
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/index.scss";
    @import "@/assets/scss/views/Input.scss";
</style>
